
export default {
    name: "feedback",
    data() {
        return {
            message:''
        };
    },
    methods:{
        bind(){
            if( this.message === '' ){
                this.$dialog.alert({
                    message: this.$t('feedback.FeedbackContentCannotBeEmpty'),
                    confirmButtonText: this.$t('team.affirm')
                })
            }else{
                this.$post2("im/index/feedback", {
                  msg:this.message
                })
                .then( (res) => {
                    this.$toast(this.$t('feeddback.FeedbackSuccess'));
                    this.$router.go(-1);
                }).catch(err=>{
                    this.$toast(err);
                })
            }
        },
    }
};
